"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  SUCCESS: "@@general/success",
  ERROR: "@@general/error",
  RESET: "@@general/reset",
  RESET_PASSWORD: "@@general/reset-password",
  CHANGE_STATUS: "@@general/change-status",
  FORGOT_PASSWORD: "@@general/forgot-password",
  SAVE_PASSWORD: "@@general/save-password",
  UNIQUE_ACCESS: "@@general/unique-access",
  VALIDATE_PASSWORD: "@@general/validate-password",
  VALIDATE_TOKEN: "@@general/validate-token",
  RESET_PASSWORD_COMMON_RESET: "@@general/reset-password-common-reset"
};
exports.actionTypes = actionTypes;